import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AddUserComponent } from '../add-user/add-user.component';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { ChangeEmailComponent } from '../change-email/change-email.component';
import { AdminService } from '../admin.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService } from '../../services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})
export class UserManagementComponent implements OnInit, AfterViewInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<any>;

  users: any[];
  displayedColumns: string[] = ['id', 'username', 'email', 'role', 'abosId', 'changePassword', 'changeEmail'];
  dataSource = new MatTableDataSource<any>();

  constructor(private readonly adminService: AdminService,
              private readonly modalService: BsModalService,
              private readonly snackBar: MatSnackBar,
              private readonly authenticationService: AuthenticationService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute,
              private readonly toastr: ToastrService) {
  }

  ngOnInit(): void {
    this.users = this.activatedRoute.parent.snapshot.data['preload'].users;
    this.dataSource.data = this.activatedRoute.parent.snapshot.data['preload'].users;
  }

  modifyUser(user) {
    this.adminService.modifyAbosId(user).subscribe(() => {
      this.snackBar.open(user.username + ' modified');
      this.reloadTable();
    }, error => {
      this.toastr.error(error.error);
    });
  }

  reloadTable() {
    this.adminService.getUsers().subscribe((users: any[]) => {
      this.dataSource.data = users;
    });
  }

  create() {
    const a = this.modalService.show(AddUserComponent, {
      backdrop: true,
      ignoreBackdropClick: false,
      animated: true
    });

    a.content.onHide.subscribe((resp) => {
      this.reloadTable();
    });
  }

  changePassword(username) {
    const initialState = {username};
    this.modalService.show(ChangePasswordComponent, {
      backdrop: true,
      ignoreBackdropClick: false,
      animated: true,
      initialState
    });
  }

  changeEmail(user) {
    const initialState = {username: user.username, email: user.email};
    const modal = this.modalService.show(ChangeEmailComponent, {
      backdrop: true,
      ignoreBackdropClick: true,
      animated: true,
      initialState
    });

    modal.content.onHide.subscribe(res => {
      user.email = res;
    });
  }

  ngAfterViewInit(): void {
    if (this.dataSource) {
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    }
  }
}
